var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeat3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 210,
    viewBox: "0 0 314 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_193)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 163,
    r: 200,
    fill: "#FFF7A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 163C340 240.32 277.32 303 200 303C122.68 303 60 240.32 60 163C60 85.6801 122.68 23 200 23C277.32 23 340 85.6801 340 163ZM116 163C116 209.392 153.608 247 200 247C246.392 247 284 209.392 284 163C284 116.608 246.392 79 200 79C153.608 79 116 116.608 116 163Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 87,
    r: 43,
    fill: "#FFB400",
    stroke: "white",
    strokeWidth: 14
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 247,
    fill: "white",
    transform: "translate(0 -37)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat3);
export default __webpack_public_path__ + "static/media/feat-3.b53230627abe32b6badd9823da05ef2a.svg";
export { ForwardRef as ReactComponent };